import { app } from '../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.hard-token-management', {
        url: '/hard-token-management',
        component: 'companyHardTokenManagement',
        resolve: {hardTokens},
    })
}

/** @ngInject */
function hardTokens($filter, HardTokenService) {
    return HardTokenService.list().then((items) => $filter('orderBy')(items, 'effectiveStatus'));
}



// WEBPACK FOOTER //
// ./src/portal/states/company/hard-token-management/hard-token-management.state.js